import { normalizeTireHealth } from "./tireWear.js";
export const REPLAY_SCHEMA_VERSION = "replay-v1";
export function quantizeVehicleState(state, decimals = 4) {
    const scale = 10 ** decimals;
    const q = (value) => Math.round(value * scale) / scale;
    return {
        position: { x: q(state.position.x), y: q(state.position.y) },
        headingRad: q(state.headingRad),
        longitudinalSpeed: q(state.longitudinalSpeed),
        lateralSpeed: q(state.lateralSpeed),
        yawRate: q(state.yawRate),
        steeringAngleRad: q(state.steeringAngleRad),
        ...(state.tires
            ? {
                tires: Object.fromEntries(Object.entries(normalizeTireHealth(state.tires)).map(([wheel, health]) => [wheel, q(health)])),
            }
            : {}),
        ...(state.pitServiceContact !== undefined
            ? { pitServiceContact: state.pitServiceContact }
            : {}),
        ...(state.pitStopVisitCount !== undefined
            ? {
                pitStopVisitCount: Math.max(0, Math.min(255, Math.trunc(state.pitStopVisitCount))),
            }
            : {}),
    };
}
export function hashQuantizedState(state, decimals = 4) {
    const value = JSON.stringify(quantizeVehicleState(state, decimals));
    return hashString(value);
}
export function hashConfig(config) {
    return hashString(JSON.stringify(config));
}
/** Canonical track tuning hash, including optional pit limiter parameters. */
export function hashTrackPhysicsConfig(config) {
    return hashString(JSON.stringify({
        drag: config.drag,
        torque: config.torque,
        trackMaxSpeed: config.trackMaxSpeed,
        gravelDrag: config.gravelDrag,
        gravelTorque: config.gravelTorque,
        gravelMaxSpeed: config.gravelMaxSpeed,
        grassDrag: config.grassDrag,
        grassTorque: config.grassTorque,
        grassMaxSpeed: config.grassMaxSpeed,
        pitSpeedLimitRatio: config.pitSpeedLimitRatio ?? 0.5,
        pitLimiterDeceleration: config.pitLimiterDeceleration ?? 0.12,
    }));
}
function hashString(value) {
    let hash = 0x811c9dc5;
    for (let index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16).padStart(8, "0");
}
export async function sha256Hex(bytes) {
    const digest = await globalThis.crypto.subtle.digest("SHA-256", bytes);
    return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}
export async function verifyManifestHash(bytes, expectedHash) {
    const actual = await sha256Hex(bytes);
    if (actual !== expectedHash)
        throw new Error(`Map manifest hash mismatch: expected ${expectedHash}, got ${actual}`);
}
